import React from "react";
import CrudErrors from "components/CrudErros";
import C from "helpers/HelpConstants";
import { HelpAbility } from "helpers/HelpAbility";

const ProductCrudTableForm = ({ setForm, form, createData, updateData, handleReset, errors }) => {

    let myAbi = HelpAbility();

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    }
    const handleChangeBool = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value === 'true' });
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        if (form._id === null) {
            createData(form);
        } else {
            updateData(form);
        }
    }

    const isVisibleForm = () => (form._id === null) ? myAbi.has(C.A.PRODUCT.CREATE) : myAbi.has(C.A.PRODUCT.UPDATE);

    return (
        <>
            {isVisibleForm() && <div className="mt-4">
                <div className="row mb-2">
                    <h6>{form._id ? 'Editar' : 'Agregar'} Producto</h6>
                </div>
                {errors && <CrudErrors errors={errors} />}

                <div className="table-responsive rounded-3"
                    style={{ border: '1px solid black', paddingTop: '15px' }}>
                    <>
                        <div className="row mb-3 d-flex justify-content-center">
                            <div className="col-3 themed-grid-col" style={{ paddingRight: '10px' }}>
                                <div className="mb-3">
                                    <label htmlFor="sku" className="form-label">SKU PADRE</label>
                                    <input type="text" className="form-control" data-bind="value:replyNumber" id="sku"
                                        name="sku" autoComplete="off" value={form.sku} onChange={handleChange} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="skuHijo" className="form-label">SKU HIJO</label>
                                    <input type="text" className="form-control" data-bind="value:replyNumber" id="skuHijo"
                                        name="skuHijo" autoComplete="off" value={form.skuHijo} onChange={handleChange} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="name" className="form-label">Nombre de Producto</label>
                                    <input type="text" className="form-control" id="name" name="name" autoComplete="off"
                                        value={form.name} onChange={handleChange} />
                                </div>
                            </div>
                            <div className="col-3 themed-grid-col" style={{ paddingLeft: '10px' }}>
                                <div className="mb-3">
                                    <label htmlFor="priceWithoutIva" className="form-label">Precio base (sin IVA)</label>
                                    <input type="number" className="form-control" id="priceWithoutIva"
                                        name="priceWithoutIva" autoComplete="off" value={form.priceWithoutIva}
                                        onChange={handleChange} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="discount" className="form-label">Descuento</label>
                                    <input type="number" className="form-control" id="discount"
                                        name="discount" autoComplete="off" value={form.discount}
                                        onChange={handleChange} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="iva" className="form-label">IVA</label>
                                    <input type="number" className="form-control" id="iva" name="iva"
                                        autoComplete="off"
                                        value={form.iva} onChange={handleChange} />
                                </div>
                                <div className="row mb-3">
                                    <div className="col">
                                        <label htmlFor="name" className="form-label">Tiene Stock</label>
                                    </div>
                                    <div className="col">
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="haveStock"
                                                onChange={handleChangeBool}
                                                checked={form.haveStock === true} id="isVisible-radio-true"
                                                value={true} />
                                            <label className="form-check-label" htmlFor="isVisible-radio-true">Si</label>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="haveStock"
                                                onChange={handleChangeBool}
                                                checked={form.haveStock === false} id="isVisible-radio-false"
                                                value={false} />
                                            <label className="form-check-label" htmlFor="isVisible-radio-false">No</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-grid gap-2">
                                    {/*<button className="btn btn-info me-2" type="submit" onClick={handleSubmit}>{form._id ? 'Actualizar' : 'Guardar'}</button> */}
                                    {/*'btn btn-' + form._id ? 'info' : 'primary' + ' me-2'*/}
                                    <button className={'btn btn-' + (form._id ? 'success' : 'primary')} type="submit"
                                        onClick={handleSubmit}><i
                                            className="bi bi-save" />{form._id ? 'Actualizar' : 'Guardar'}</button>
                                    <button type="reset" className="btn btn-secondary" onClick={handleReset}><i
                                        className="bi bi-eraser" /> Limpiar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </>
                </div>
            </div>}
        </>
    );
}
export default ProductCrudTableForm;
